import axios from "axios"
const API_BASE = '__VUE_APP_API_BASE_URL__';
const instance = axios.create({
    // baseURL: process.env.VUE_APP_API_BASE_URL,
    baseURL: API_BASE,
})

instance.defaults.headers.post['Content-Type'] = 'application/json';
instance.defaults.method = "post";
export default instance